/* Common */
export const HOME_PAGE_PATH = '/';
export const PAGE_PATH = '/page';
export const SEARCH_PAGE_PATH = '/page/:combinedSearch';
export const STATUS_PATH = '/status';
export const STATIC_INDICATIONS_PATH = '/indications';
